var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "isOpen", "onClose", "title", "titleProps", "subTitle", "iconProps", "icon", "role", "primaryAction", "showSecondaryActionButton", "secondaryAction", "showTertiaryActionButton", "tertiaryAction", "showCloseActionButton", "showHeader", "closeAction", "closeOnOverlayClick", "closeOnEsc", "variant", "sx"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as TQCModal from '../../../components/modal';
import { Box, Button, HStack, Icon, Typography, VStack, Text, useBreakpointValue } from '../../../components';
import { useLocale } from '../../utils';
import React from 'react';
import { FaExclamationCircle, FaExclamationTriangle } from 'react-icons/fa';
var Body = _ref => {
  var {
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var locale = useLocale();
  var isWales = locale === 'wales';
  return /*#__PURE__*/React.createElement(Box, _extends({
    sx: {
      '> .tqc-modal__body-row:not(:first-child)': {
        borderTop: '1px solid',
        borderTopColor: 'grey.300'
      },
      '> .tqc-modal__body-row:first-child': {
        mt: '-1.5rem'
      },
      '> .tqc-modal__body-row:last-child': {
        mb: '-1.5rem'
      },
      '> .tqc-modal__body-row:nth-child(odd)': {
        bg: isWales ? 'grey.400' : 'grey.100'
      }
    }
  }, rest), children);
};
var Row = _ref2 => {
  var {
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(VStack, _extends({
    alignItems: "flex-start",
    spacing: 4,
    mx: {
      base: '-1.25rem',
      md: '-2rem'
    },
    px: {
      base: '1.25rem',
      md: '2rem'
    },
    py: "1.5rem",
    className: "tqc-modal__body-row"
  }, rest), children);
};
var Modal = props => {
  var {
      children,
      isOpen,
      onClose,
      title,
      titleProps,
      subTitle,
      iconProps,
      icon,
      role = 'dialog',
      primaryAction: primaryActionProps,
      showSecondaryActionButton = true,
      secondaryAction: secondaryActionProps,
      showTertiaryActionButton = false,
      tertiaryAction: tertiaryActionProps,
      showCloseActionButton = true,
      showHeader = true,
      closeAction: closeActionProps,
      closeOnOverlayClick = false,
      closeOnEsc = false,
      variant,
      sx: sxProps
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  var locale = useLocale();
  var size = useBreakpointValue({
    base: 'full',
    md: '3xl'
  });
  var sx = _objectSpread({
    '.tqc-modal__body': _objectSpread({}, showHeader ? {} : {
      py: {
        base: '1.5rem',
        md: '2rem'
      }
    })
  }, sxProps);
  var modalProps = _objectSpread({
    size,
    'aria-labelledby': undefined,
    'aria-label': title
  }, rest);
  var showFooter = !!primaryActionProps || !!secondaryActionProps;
  var modalCloseButtonProps = _objectSpread(_objectSpread(_objectSpread({}, locale === 'wales' ? {
    color: 'white',
    bg: 'grey.980',
    fontSize: '1rem',
    lineHeight: '2rem',
    height: '2rem'
  } : {}), {
    alignSelf: ['baseline', 'center']
  }), closeActionProps);
  var modalHeaderPadding = _objectSpread({}, locale === 'wales' ? {
    py: '1rem'
  } : {});
  var titleContainer = _objectSpread({}, locale === 'england' ? {
    maxWidth: ['15.375rem', 'revert']
  } : {});
  var modalContentMargin = {
    mx: {
      base: 0,
      md: '2.5rem',
      lg: 0
    }
  };
  var primaryButtonVariant = variant === 'danger' ? 'danger' : 'primary';
  var primaryButtonProps = _objectSpread({
    variant: primaryButtonVariant
  }, primaryActionProps);
  var modalFooterProps = {
    locale,
    primaryActionProps: primaryButtonProps,
    secondaryActionProps,
    showSecondaryActionButton,
    tertiaryActionProps,
    showTertiaryActionButton
  };
  var titleIcon = React.useMemo(() => {
    if (icon) {
      return icon;
    } else if (variant === 'danger' && locale !== 'wales') {
      return /*#__PURE__*/React.createElement(Icon, _extends({
        as: FaExclamationCircle,
        boxSize: "1.5rem",
        color: "red.700"
      }, iconProps));
    } else if (variant === 'warning' && locale !== 'wales') {
      return /*#__PURE__*/React.createElement(Icon, _extends({
        as: FaExclamationTriangle,
        boxSize: "1.5rem",
        color: "orange.700"
      }, iconProps));
    }
    return null;
  }, [icon, variant, locale, iconProps]);
  return /*#__PURE__*/React.createElement(TQCModal.Modal, _extends({
    isCentered: true,
    isOpen: isOpen,
    onClose: onClose
  }, modalProps, {
    closeOnOverlayClick: closeOnOverlayClick,
    closeOnEsc: closeOnEsc
  }), /*#__PURE__*/React.createElement(TQCModal.ModalOverlay, null), /*#__PURE__*/React.createElement(TQCModal.ModalContent, _extends({
    "aria-label": props['aria-label']
  }, modalContentMargin, {
    role: role,
    sx: sx
  }), showHeader && /*#__PURE__*/React.createElement(TQCModal.ModalHeader, modalHeaderPadding, /*#__PURE__*/React.createElement(VStack, {
    isFullWidth: true,
    align: "start",
    spacing: 3
  }, /*#__PURE__*/React.createElement(HStack, {
    isFullWidth: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(HStack, _extends({}, titleContainer, {
    spacing: 3
  }), titleIcon, /*#__PURE__*/React.createElement(Typography, _extends({
    as: "h1"
  }, titleProps), title)), showCloseActionButton && /*#__PURE__*/React.createElement(TQCModal.ModalCloseButton, modalCloseButtonProps)), subTitle && /*#__PURE__*/React.createElement(HStack, {
    spacing: 3,
    isFullWidth: true,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "sm"
  }, subTitle)))), /*#__PURE__*/React.createElement(TQCModal.ModalBody, null, children), showFooter && /*#__PURE__*/React.createElement(ModalFooter, modalFooterProps)));
};
var ModalFooter = props => {
  var {
    locale,
    primaryActionProps,
    secondaryActionProps,
    showSecondaryActionButton,
    tertiaryActionProps,
    showTertiaryActionButton
  } = props;
  var walesButtonWidth = {
    sx: {
      minWidth: 'auto !important',
      width: 'fit-content'
    }
  };
  var isFullWidth = useBreakpointValue({
    base: true,
    md: false
  });
  var sharedActionProps = {
    isFullWidth: isFullWidth !== null && isFullWidth !== void 0 ? isFullWidth : false
  };
  return locale === 'wales' ? /*#__PURE__*/React.createElement(TQCModal.ModalFooter, {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: {
      base: 'column',
      md: 'row'
    }
  }, /*#__PURE__*/React.createElement(Button, _extends({}, primaryActionProps, walesButtonWidth)), showSecondaryActionButton && /*#__PURE__*/React.createElement(Button, _extends({
    mt: {
      base: 6,
      md: 'unset'
    },
    ml: {
      md: 3
    },
    variant: "tertiary"
  }, secondaryActionProps, walesButtonWidth))) : /*#__PURE__*/React.createElement(TQCModal.ModalFooter, {
    flexDirection: {
      base: 'column',
      md: 'row'
    }
  }, showTertiaryActionButton && /*#__PURE__*/React.createElement(Button, _extends({
    mt: {
      base: 8,
      md: 'unset'
    },
    variant: "tertiary"
  }, sharedActionProps, tertiaryActionProps)), showSecondaryActionButton && /*#__PURE__*/React.createElement(Button, _extends({
    mt: {
      base: 8,
      md: 'unset'
    },
    variant: "tertiary"
  }, sharedActionProps, secondaryActionProps)), /*#__PURE__*/React.createElement(Button, _extends({
    ml: {
      md: 3
    },
    order: {
      base: -1,
      md: 'unset'
    }
  }, sharedActionProps, primaryActionProps)));
};
Modal.Body = Body;
Modal.Row = Row;
export { Modal };